import { BROADCAST_TOGGLE_SCREEN_ACTIVE } from 'actions/Types';

function toggleScreenShareActive() {
  return (dispatch, getState) => {
    const {
      meeting: { meetingSession },
      isScreenShareActive
    } = getState();

    const action = {
      type: BROADCAST_TOGGLE_SCREEN_ACTIVE,
      request: async () => {
        if (isScreenShareActive) {
          await meetingSession.audioVideo.stopContentShare();
        }
      }
    };

    dispatch(action);
  };
}

export default toggleScreenShareActive;
